import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-opportunity';
import type { TableColumn } from '@ctw/shared/components/table/table';
import { ConfidenceIcon } from '@ctw/shared/content/patient-risk-gaps/helpers/confidence-signals';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const riskColumnsClassNames = {
  name: 'min-w-[130px] pr-4',
  rafScore: 'w-[95px] pr-4',
  hccCode: 'w-[90px] pr-4',
  type: 'w-[110px] pr-4 capitalize',
  details: 'pr-4',
} as const;

export const patientRiskGapsColumns: Array<TableColumn<RiskGapModel>> = [
  {
    title: 'Name',
    className: riskColumnsClassNames.name,
    dataIndex: 'title',
  },
  {
    title: 'RAF',
    className: riskColumnsClassNames.rafScore,
    dataIndex: 'rafScoreDisplay',
  },
  {
    title: 'HCC',
    className: riskColumnsClassNames.hccCode,
    dataIndex: 'hccCode',
  },
  {
    title: 'Type',
    className: riskColumnsClassNames.type,
    dataIndex: 'type',
  },
  {
    title: 'Details',
    className: riskColumnsClassNames.details,
    render: (record) => {
      if (record.type === 'recapture' && record.lastDiagnosedDisplay) {
        return (
          <div className="space-x-1 whitespace-nowrap">
            <FontAwesomeIcon icon={faCalendar} className="text-content-icon" />
            <span className="text-sm">Last diagnosed {record.lastDiagnosedDisplay}</span>
          </div>
        );
      }
      if (record.type === 'suspect' && record.confidenceRating !== undefined) {
        return (
          <div className="space-x-1 whitespace-nowrap">
            <ConfidenceIcon rating={record.confidenceRating} />
            <span className="uppercase">{record.confidenceRating} Confidence</span>
          </div>
        );
      }
      return null;
    },
  },
];
